module.exports = __webpack_public_path__ + "img/15.65dc45b4.png";